/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  EntityNotFoundErrorDetailsErrorResponseModel,
  ForgotPasswordDto,
  InvalidPropertyValueErrorDetailsErrorResponseModel,
  MessageResponseDto,
  ResetPasswordDto,
} from '../models/index';
import {
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    ForgotPasswordDtoFromJSON,
    ForgotPasswordDtoToJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelFromJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelToJSON,
    MessageResponseDtoFromJSON,
    MessageResponseDtoToJSON,
    ResetPasswordDtoFromJSON,
    ResetPasswordDtoToJSON,
} from '../models/index';

export interface PasswordForgotPasswordPOSTRequest {
    forgotPasswordDto?: ForgotPasswordDto;
}

export interface PasswordResetPasswordPOSTRequest {
    resetPasswordDto?: ResetPasswordDto;
}

/**
 * PasswordApi - interface
 * 
 * @export
 * @interface PasswordApiInterface
 */
export interface PasswordApiInterface {
    /**
     * Creates request options for passwordForgotPasswordPOST without sending the request
     * @param {ForgotPasswordDto} [forgotPasswordDto] 
     * @throws {RequiredError}
     * @memberof PasswordApiInterface
     */
    passwordForgotPasswordPOSTRequestOpts(requestParameters: PasswordForgotPasswordPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {ForgotPasswordDto} [forgotPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApiInterface
     */
    passwordForgotPasswordPOSTRaw(requestParameters: PasswordForgotPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>>;

    /**
     */
    passwordForgotPasswordPOST(requestParameters: PasswordForgotPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto>;

    /**
     * Creates request options for passwordResetPasswordPOST without sending the request
     * @param {ResetPasswordDto} [resetPasswordDto] 
     * @throws {RequiredError}
     * @memberof PasswordApiInterface
     */
    passwordResetPasswordPOSTRequestOpts(requestParameters: PasswordResetPasswordPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {ResetPasswordDto} [resetPasswordDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PasswordApiInterface
     */
    passwordResetPasswordPOSTRaw(requestParameters: PasswordResetPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>>;

    /**
     */
    passwordResetPasswordPOST(requestParameters: PasswordResetPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto>;

}

/**
 * 
 */
export class PasswordApi extends runtime.BaseAPI implements PasswordApiInterface {

    /**
     * Creates request options for passwordForgotPasswordPOST without sending the request
     */
    async passwordForgotPasswordPOSTRequestOpts(requestParameters: PasswordForgotPasswordPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Password/forgot`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ForgotPasswordDtoToJSON(requestParameters['forgotPasswordDto']),
        };
    }

    /**
     */
    async passwordForgotPasswordPOSTRaw(requestParameters: PasswordForgotPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>> {
        const requestOptions = await this.passwordForgotPasswordPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async passwordForgotPasswordPOST(requestParameters: PasswordForgotPasswordPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto> {
        const response = await this.passwordForgotPasswordPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for passwordResetPasswordPOST without sending the request
     */
    async passwordResetPasswordPOSTRequestOpts(requestParameters: PasswordResetPasswordPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Password/reset`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ResetPasswordDtoToJSON(requestParameters['resetPasswordDto']),
        };
    }

    /**
     */
    async passwordResetPasswordPOSTRaw(requestParameters: PasswordResetPasswordPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MessageResponseDto>> {
        const requestOptions = await this.passwordResetPasswordPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async passwordResetPasswordPOST(requestParameters: PasswordResetPasswordPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MessageResponseDto> {
        const response = await this.passwordResetPasswordPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
